import cx from 'classnames';
import { PropsWithChildren } from 'react';
import Box, { BoxStyleProps } from '../../Box';

import styles from './DialogBody.module.css';

interface DialogBodyProps extends BoxStyleProps {
  className?: string;
}

export default function DialogBody({
  className,
  children,
  ...otherProps
}: PropsWithChildren<DialogBodyProps>): JSX.Element {
  return <Box className={cx(styles['base'], className)} {...otherProps}>{children}</Box>;
}
